import {Button, Card, Col, DatePicker, Empty, Form, message, Row, Skeleton, Spin, Table} from "antd";
import React, {Component} from "react";
import moment from "moment";
import FieldSearchForm from "../../components/FieldSearchForm";
import "./style.css";
import MapView from "./MapView";


class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMapVisible: false,
      mapData: null
    };
  }

  handleClear = () => {
    this.props.clearReportData();
  };

  hideMapVisible = () => {
    this.setState((prevState) => ({
      isMapVisible: false,
      mapData: null
    }))
  }

  showMapView = (data) => {
    this.setState({
      isMapVisible: true,
      mapData: data,
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      // if (err) {
      //   return console.log(err);
      // }
      if (moment(values.periodFrom).isSameOrBefore(values.periodTo)) {
        const _values = Object.assign(values);
        _values.periodFrom = moment(values.periodFrom).toISOString();
        _values.periodTo = moment(values.periodTo).toISOString();
        this.props.generateReport(_values);
      } else {
        message.error("Period From couldn't come earlier than Period To!");
      }
    });
  };

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {loading, title, resource, reportData} = this.props;

    const cols = [
      {
        title: "Date",
        dataIndex: "attendanceDate",
        key: "attendanceDate",
        render: (attendanceDate) => moment(attendanceDate).format('DD-MM-YYYY')
      },
      {
        title: "Type",
        dataIndex: "attendanceType",
        key: "attendanceType",
        // render: (attendanceType) => (row.type && row.type.name ? row.type.name : "-")
      },
      {
        title: "Time",
        dataIndex: "attendanceTime",
        key: "attendanceTime",
        render: (attendanceTime) => moment.utc(moment.duration(attendanceTime).asMilliseconds()).format('hh:mm A')
      },
      {
        title: 'Lat/Lng', dataIndex: 'latitude', key: 'latitude',
        render: (_, data) => {
          let lat = 0, lng = 0;
          if (data && data['latitude']) {
            lat = data['latitude'];
            lng = data['longitude'];
          }
          return (lat && lng) ? <Button
            type={'link'}
            onClick={() => this.showMapView(data)}><i className='icon-map-drawing' style={{fontSize:'20px'}}/></Button> : null;

        }
      },
    ];

    return (
      <div>
        <Spin spinning={loading}>
          <Card
            className={`gx-card-metrics`}
            // title={`${sanitizeFieldName(resource)} ${title}`}
          >
            <Form
              onSubmit={this.handleSubmit}
              className="ant-advanced-search-form"
              layout="inline"
              labelAlign="left"
            >
              <Row gutter={8}>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item
                    key={"periodFrom"}
                    label={"Select Period From"}
                    style={{width: "100%"}}
                  >
                    {getFieldDecorator(`periodFrom`, {
                      rules: [
                        {required: true, message: `Period From is required!`}
                      ],
                      initialValue: null
                    })(<DatePicker style={{width: "100%"}}/>)}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item
                    key={"periodTo"}
                    label={"Select Period To"}
                    style={{width: "100%"}}
                  >
                    {getFieldDecorator(`periodTo`, {
                      rules: [
                        {required: true, message: `Period To is required!`}
                      ],
                      initialValue: null
                    })(<DatePicker style={{width: "100%"}}/>)}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <FieldSearchForm
                    title={title}
                    key={"manpower"}
                    name={`manpower`}
                    label={"Select Manpower Name"}
                    message={`Manpower is required`}
                    required={true}
                    field={"name"}
                    model={"Manpower"}
                    getFieldDecorator={getFieldDecorator}
                    setFieldsValue={setFieldsValue}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item key={"button"} style={{width: "100%", top: 25}}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Generate Report
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
          <Card className={`gx-card-metrics`}>
            <div>
              {loading ? (
                <Skeleton active/>
              ) : reportData && reportData.length ? <Table columns={cols} dataSource={reportData} loading={loading}/> :
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
              }
            </div>
          </Card>
        </Spin>
        <MapView isVisible={this.state.isMapVisible} hideVisible={this.hideMapVisible} data={this.state.mapData}/>
      </div>
    );
  }
}

const CreateForm = Form.create({
  name: "global_state"
})(Report);
export default CreateForm;
